// // // // import React from 'react';
// // // // import { Link } from 'react-router-dom';
// // // // import { useLanguage } from '../../context/LanguageContext';

// // // // const HomeBanner = () => {
// // // //   const { t } = useLanguage();

// // // //   return (
// // // //     <section className="cf-hero">
// // // //       <div className="container position-relative" style={{ zIndex: 1 }}>
// // // //         <div className="row align-items-center g-5">

// // // //           {/* ── Left: Text ── */}
// // // //           <div className="col-lg-6">
// // // //             <span className="eyebrow-badge anim-fade anim-delay-1">
// // // //               <i className="bi bi-flower1"></i>
// // // //               {t('home.heroEyebrow')}
// // // //             </span>

// // // //             <h1 className="hero-title mb-2 anim-fade-up anim-delay-2">
// // // //               {/* {t('home.heroTitle')}
// // // //               <br /> */}
// // // //               <em>{t('home.heroTitleEm')}</em>
// // // //             </h1>

// // // //             <p className="hero-subtitle mb-3 anim-fade-up anim-delay-3">
// // // //               {t('home.heroSubtitle')}
// // // //             </p>

// // // //             <p className="hero-desc mb-4 anim-fade-up anim-delay-4">
// // // //               {t('home.heroDesc')}
// // // //             </p>

// // // //             {/* CTA Buttons */}
// // // //             <div className="d-flex flex-wrap gap-3 mb-4 anim-fade-up anim-delay-5">
// // // //               <Link to="/who-is-chaitralee" className="btn-brand">
// // // //                 {t('home.ctaLearnMore')}
// // // //                 <i className="bi bi-arrow-right"></i>
// // // //               </Link>
// // // //               <Link to="/you-can" className="btn-brand-outline">
// // // //                 {t('home.ctaJoin')}
// // // //                 <i className="bi bi-heart"></i>
// // // //               </Link>
// // // //             </div>

// // // //             {/* Dates badge */}
// // // //             <div className="hero-dates-badge anim-fade anim-delay-6">
// // // //               <div className="text-center">
// // // //                 <div className="hero-date-label">{t('home.heroBorn')}</div>
// // // //                 <div className="hero-date-desc">{t('home.heroBornLabel')}</div>
// // // //               </div>
// // // //               <div className="hero-divider-v"></div>
// // // //               <div className="text-center">
// // // //                 <div className="hero-date-label" style={{ color: 'rgba(253,246,236,0.65)' }}>{t('home.heroPassed')}</div>
// // // //                 <div className="hero-date-desc">{t('home.heroPassedLabel')}</div>
// // // //               </div>
// // // //             </div>
// // // //           </div>

// // // //           {/* ── Right: Creative Image Collage ── */}
// // // //           <div className="col-lg-6 anim-fade anim-delay-3">
// // // //             <div className="hero-collage">
// // // //               <div className="hero-collage-grid">

// // // //                 {/* Main large portrait */}
// // // //                 {/* <div className="hero-col-main">
// // // //                   <div className="placeholder-img-main">
// // // //                     <i className="bi bi-person-bounding-box mb-3" style={{fontSize:'3.5rem',color:'rgba(255,255,255,0.18)'}}></i>
// // // //                     <span style={{fontSize:'0.7rem',color:'rgba(255,255,255,0.22)',fontFamily:'Hind,sans-serif',letterSpacing:'0.04em'}}>
// // // //                       public/assets/images/chaitralee-log.jpeg
// // // //                     </span>
// // // //                   </div>
// // // //                   <div className="hero-col-caption">
// // // //                     <div className="hero-caption-quote">"Rose Colour Glasses"</div>
// // // //                     <div className="hero-caption-sub">Her philosophy. Her legacy.</div>
// // // //                   </div>
// // // //                 </div> */}

// // // //                 <div className="hero-col-main">
// // // //                   <img
// // // //                     src="/assets/images/chaitralee-log.jpeg"
// // // //                     alt="Chaitralee Foundation"
// // // //                     className="hero-main-img"
// // // //                   />

// // // //                   <div className="hero-col-caption">
// // // //                     <div className="hero-caption-quote">"Rose Colour Glasses"</div>
// // // //                     <div className="hero-caption-sub">Her philosophy. Her legacy.</div>
// // // //                   </div>
// // // //                 </div>

// // // //                 {/* Top right small */}
// // // //                 <div className="hero-col-sm">
// // // //                   <img
// // // //                     src="/assets/images/767.jpg.jpeg"
// // // //                     alt="Chaitralee"
// // // //                     className="placeholder-img-sm"
// // // //                   />
// // // //                 </div>

// // // //                 {/* Bottom right small with badge */}
// // // //                 <div className="hero-col-sm2">
// // // //                   <img
// // // //                     src="/assets/images/700.jpg.jpeg"
// // // //                     alt="Chaitralee"
// // // //                     className="placeholder-img-sm2"
// // // //                   />
// // // //                 </div>

// // // //               </div>
// // // //             </div>
// // // //           </div>

// // // //         </div>
// // // //       </div>
// // // //     </section>
// // // //   );
// // // // };

// // // // export default HomeBanner;




// // // import React, { useRef, useEffect } from 'react';
// // // import { Link } from 'react-router-dom';
// // // import { useLanguage } from '../../context/LanguageContext';

// // // // ─── Carousel strip (infinite auto-scroll) ───────────────────────────────────
// // // const CarouselStrip = ({ images, direction = 'left', speed = 30 }) => {
// // //   const trackRef = useRef(null);
// // //   const animRef  = useRef(null);
// // //   const posRef   = useRef(0);

// // //   useEffect(() => {
// // //     const track = trackRef.current;
// // //     if (!track) return;

// // //     // Duplicate items so the strip loops seamlessly
// // //     const items      = Array.from(track.children);
// // //     const half       = items.length;          // original count (already doubled in JSX)
// // //     const totalWidth = () => track.scrollWidth / 2;

// // //     const step = () => {
// // //       const delta = direction === 'left' ? -0.4 : 0.4;
// // //       posRef.current += delta * (speed / 30);

// // //       if (direction === 'left'  && Math.abs(posRef.current) >= totalWidth()) posRef.current = 0;
// // //       if (direction === 'right' && posRef.current >= 0) posRef.current = -totalWidth();

// // //       track.style.transform = `translateX(${posRef.current}px)`;
// // //       animRef.current = requestAnimationFrame(step);
// // //     };

// // //     // Start offset for right-direction strip
// // //     if (direction === 'right') posRef.current = -totalWidth();

// // //     animRef.current = requestAnimationFrame(step);
// // //     return () => cancelAnimationFrame(animRef.current);
// // //   }, [direction, speed]);

// // //   // Double the images for seamless loop
// // //   const doubled = [...images, ...images];

// // //   return (
// // //     <div className="cf-carousel-wrap">
// // //       <div className="cf-carousel-track" ref={trackRef}>
// // //         {doubled.map((src, i) => (
// // //           <div className="cf-carousel-item" key={i}>
// // //             <img src={src} alt="" loading="lazy" />
// // //           </div>
// // //         ))}
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // // ─── Component ────────────────────────────────────────────────────────────────
// // // const HomeBanner = () => {
// // //   const { t } = useLanguage();

// // //   // ── Swap / add your own image paths here ────────────────────────────────
// // //   const featuredImage  = '/assets/images/chaitralee-log.jpeg';

// // //   const topImages = [
// // //     '/assets/images/767.jpg.jpeg',
// // //     '/assets/images/700.jpg.jpeg',
// // //     '/assets/images/767.jpg.jpeg',
// // //     '/assets/images/700.jpg.jpeg',
// // //     '/assets/images/767.jpg.jpeg',
// // //   ];

// // //   const bottomImages = [
// // //     '/assets/images/700.jpg.jpeg',
// // //     '/assets/images/767.jpg.jpeg',
// // //     '/assets/images/700.jpg.jpeg',
// // //     '/assets/images/767.jpg.jpeg',
// // //     '/assets/images/700.jpg.jpeg',
// // //   ];
// // //   // ────────────────────────────────────────────────────────────────────────

// // //   return (
// // //     <>
// // //       {/* ── Scoped styles ── */}
// // //       <style>{`
// // //         /* ── Gallery column ── */
// // //         .cf-gallery-col {
// // //           display: flex;
// // //           flex-direction: column;
// // //           gap: 14px;
// // //           align-items: center;
// // //         }

// // //         /* ── Carousel wrap (clips overflow) ── */
// // //         .cf-carousel-wrap {
// // //           width: 100%;
// // //           overflow: hidden;
// // //           border-radius: 12px;
// // //           mask-image: linear-gradient(
// // //             to right,
// // //             transparent 0%,
// // //             black 12%,
// // //             black 88%,
// // //             transparent 100%
// // //           );
// // //           -webkit-mask-image: linear-gradient(
// // //             to right,
// // //             transparent 0%,
// // //             black 12%,
// // //             black 88%,
// // //             transparent 100%
// // //           );
// // //         }

// // //         /* ── Carousel track (flex, no-wrap) ── */
// // //         .cf-carousel-track {
// // //           display: flex;
// // //           flex-wrap: nowrap;
// // //           gap: 12px;
// // //           will-change: transform;
// // //         }

// // //         /* ── Individual thumbnail ── */
// // //         .cf-carousel-item {
// // //           flex: 0 0 auto;
// // //           width: 110px;
// // //           height: 80px;
// // //           border-radius: 10px;
// // //           overflow: hidden;
// // //           border: 2px solid rgba(255,255,255,0.12);
// // //           box-shadow: 0 4px 16px rgba(0,0,0,0.25);
// // //           transition: transform 0.3s ease, border-color 0.3s ease;
// // //         }

// // //         .cf-carousel-item:hover {
// // //           transform: scale(1.06);
// // //           border-color: rgba(255,200,100,0.55);
// // //         }

// // //         .cf-carousel-item img {
// // //           width: 100%;
// // //           height: 100%;
// // //           object-fit: cover;
// // //           display: block;
// // //         }

// // //         /* ── Featured image ── */
// // //         .cf-featured-wrap {
// // //           position: relative;
// // //           border-radius: 20px;
// // //           overflow: hidden;
// // //           box-shadow:
// // //             0 0 0 3px rgba(255,200,100,0.25),
// // //             0 20px 60px rgba(0,0,0,0.45);
// // //           flex: 0 0 auto;
// // //           width: 100%;
// // //           max-width: 320px;
// // //           aspect-ratio: 3/4;
// // //           background: rgba(0,0,0,0.3);
// // //         }

// // //         .cf-featured-wrap img {
// // //           width: 100%;
// // //           height: 100%;
// // //           object-fit: cover;
// // //           display: block;
// // //         }

// // //         /* Caption overlay */
// // //         .cf-featured-caption {
// // //           position: absolute;
// // //           bottom: 0;
// // //           left: 0;
// // //           right: 0;
// // //           padding: 20px 18px 16px;
// // //           background: linear-gradient(to top, rgba(0,0,0,0.75) 0%, transparent 100%);
// // //         }

// // //         .cf-featured-caption .quote {
// // //           font-family: 'Georgia', serif;
// // //           font-style: italic;
// // //           font-size: 0.85rem;
// // //           color: rgba(255,220,130,0.95);
// // //           margin-bottom: 2px;
// // //         }

// // //         .cf-featured-caption .sub {
// // //           font-size: 0.72rem;
// // //           color: rgba(255,255,255,0.6);
// // //           letter-spacing: 0.05em;
// // //         }

// // //         /* Decorative glow ring */
// // //         .cf-featured-wrap::before {
// // //           content: '';
// // //           position: absolute;
// // //           inset: -1px;
// // //           border-radius: 20px;
// // //           background: linear-gradient(135deg, rgba(255,200,80,0.35), transparent 60%);
// // //           pointer-events: none;
// // //           z-index: 1;
// // //         }

// // //         /* ── Responsive ── */
// // //         @media (max-width: 991px) {
// // //           .cf-gallery-col {
// // //             flex-direction: column;
// // //           }
// // //           .cf-featured-wrap {
// // //             max-width: 260px;
// // //             aspect-ratio: 3/4;
// // //           }
// // //           .cf-carousel-item {
// // //             width: 90px;
// // //             height: 65px;
// // //           }
// // //         }
// // //       `}</style>

// // //       <section className="cf-hero">
// // //         <div className="container position-relative" style={{ zIndex: 1 }}>
// // //           <div className="row align-items-center g-5">

// // //             {/* ── Left: Text (unchanged) ── */}
// // //             <div className="col-lg-6">
// // //               <span className="eyebrow-badge anim-fade anim-delay-1">
// // //                 <i className="bi bi-flower1"></i>
// // //                 {t('home.heroEyebrow')}
// // //               </span>

// // //               <h1 className="hero-title mb-2 anim-fade-up anim-delay-2">
// // //                 <em>{t('home.heroTitleEm')}</em>
// // //               </h1>

// // //               <p className="hero-subtitle mb-3 anim-fade-up anim-delay-3">
// // //                 {t('home.heroSubtitle')}
// // //               </p>

// // //               <p className="hero-desc mb-4 anim-fade-up anim-delay-4">
// // //                 {t('home.heroDesc')}
// // //               </p>

// // //               {/* CTA Buttons */}
// // //               <div className="d-flex flex-wrap gap-3 mb-4 anim-fade-up anim-delay-5">
// // //                 <Link to="/who-is-chaitralee" className="btn-brand">
// // //                   {t('home.ctaLearnMore')}
// // //                   <i className="bi bi-arrow-right"></i>
// // //                 </Link>
// // //                 <Link to="/you-can" className="btn-brand-outline">
// // //                   {t('home.ctaJoin')}
// // //                   <i className="bi bi-heart"></i>
// // //                 </Link>
// // //               </div>

// // //               {/* Dates badge */}
// // //               <div className="hero-dates-badge anim-fade anim-delay-6">
// // //                 <div className="text-center">
// // //                   <div className="hero-date-label">{t('home.heroBorn')}</div>
// // //                   <div className="hero-date-desc">{t('home.heroBornLabel')}</div>
// // //                 </div>
// // //                 <div className="hero-divider-v"></div>
// // //                 <div className="text-center">
// // //                   <div className="hero-date-label" style={{ color: 'rgba(253,246,236,0.65)' }}>
// // //                     {t('home.heroPassed')}
// // //                   </div>
// // //                   <div className="hero-date-desc">{t('home.heroPassedLabel')}</div>
// // //                 </div>
// // //               </div>
// // //             </div>

// // //             {/* ── Right: Gallery showcase ── */}
// // //             <div className="col-lg-6 anim-fade anim-delay-3">
// // //               <div className="cf-gallery-col">

// // //                 {/* Top carousel — scrolls left */}
// // //                 <CarouselStrip images={topImages} direction="left" speed={28} />

// // //                 {/* Featured image */}
// // //                 <div className="cf-featured-wrap">
// // //                   <img src={featuredImage} alt="Chaitralee Foundation" />
// // //                   <div className="cf-featured-caption">
// // //                     <div className="quote">"Rose Colour Glasses"</div>
// // //                     <div className="sub">Her philosophy. Her legacy.</div>
// // //                   </div>
// // //                 </div>

// // //                 {/* Bottom carousel — scrolls right (counter-direction) */}
// // //                 <CarouselStrip images={bottomImages} direction="right" speed={28} />

// // //               </div>
// // //             </div>

// // //           </div>
// // //         </div>
// // //       </section>
// // //     </>
// // //   );
// // // };

// // // export default HomeBanner;


// // import React, { useEffect, useRef } from 'react';
// // import { Link } from 'react-router-dom';
// // import { useLanguage } from '../../context/LanguageContext';

// // // ─── Floating orbit image ────────────────────────────────────────────────────
// // const OrbitImage = ({ src, style, className = '' }) => (
// //   <div className={`orbit-img ${className}`} style={style}>
// //     <img src={src} alt="" loading="lazy" />
// //     <div className="orbit-img-shine" />
// //   </div>
// // );

// // // ─── Main Component ──────────────────────────────────────────────────────────
// // const HomeBanner = () => {
// //   const { t } = useLanguage();
// //   const sceneRef = useRef(null);

// //   // Subtle parallax on mouse move
// //   useEffect(() => {
// //     const scene = sceneRef.current;
// //     if (!scene) return;

// //     const onMove = (e) => {
// //       const rect = scene.getBoundingClientRect();
// //       const cx = rect.left + rect.width  / 2;
// //       const cy = rect.top  + rect.height / 2;
// //       const dx = (e.clientX - cx) / rect.width;   // -0.5 … 0.5
// //       const dy = (e.clientY - cy) / rect.height;

// //       scene.querySelectorAll('[data-depth]').forEach(el => {
// //         const d = parseFloat(el.dataset.depth);
// //         el.style.transform = `translate(${dx * d * 22}px, ${dy * d * 18}px)`;
// //       });
// //     };

// //     window.addEventListener('mousemove', onMove);
// //     return () => window.removeEventListener('mousemove', onMove);
// //   }, []);

// //   // ── Image paths — swap freely ────────────────────────────────────────────
// //   const featured = '/assets/images/chaitralee-log.jpeg';
// //   const img1     = '/assets/images/767.jpg.jpeg';
// //   const img2     = '/assets/images/700.jpg.jpeg';
// //   // ────────────────────────────────────────────────────────────────────────

// //   return (
// //     <>
// //       <style>{`
// //         /* ═══════════════════════════════════════════════════════
// //            HERO SCENE
// //         ═══════════════════════════════════════════════════════ */
// //         .cf-hero-scene {
// //           position: relative;
// //           width: 100%;
// //           min-height: 520px;
// //           display: flex;
// //           align-items: center;
// //           justify-content: center;
// //         }

// //         /* ── Decorative rings ── */
// //         .scene-ring {
// //           position: absolute;
// //           border-radius: 50%;
// //           border: 1px solid rgba(255, 200, 100, 0.12);
// //           pointer-events: none;
// //         }
// //         .scene-ring-1 {
// //           width: 420px; height: 420px;
// //           top: 50%; left: 50%;
// //           transform: translate(-50%, -50%);
// //           animation: ring-pulse 6s ease-in-out infinite;
// //         }
// //         .scene-ring-2 {
// //           width: 560px; height: 560px;
// //           top: 50%; left: 50%;
// //           transform: translate(-50%, -50%);
// //           border-color: rgba(255, 200, 100, 0.07);
// //           animation: ring-pulse 6s ease-in-out infinite 1.5s;
// //         }
// //         @keyframes ring-pulse {
// //           0%, 100% { opacity: 0.6; }
// //           50%       { opacity: 1;   }
// //         }

// //         /* ── Featured (center) image ── */
// //         .featured-card {
// //           position: relative;
// //           z-index: 4;
// //           width: 240px;
// //           flex-shrink: 0;
// //           border-radius: 22px;
// //           overflow: hidden;
// //           box-shadow:
// //             0 0 0 2px rgba(255, 200, 80, 0.30),
// //             0 24px 64px rgba(0, 0, 0, 0.55),
// //             0  8px 20px rgba(0, 0, 0, 0.35);
// //           transition: transform 0.6s cubic-bezier(0.22, 1, 0.36, 1);
// //         }
// //         .featured-card:hover {
// //           transform: scale(1.03) translateY(-4px);
// //         }
// //         .featured-card img {
// //           width: 100%;
// //           aspect-ratio: 3 / 4;
// //           object-fit: cover;
// //           display: block;
// //         }
// //         .featured-card-caption {
// //           position: absolute;
// //           bottom: 0; left: 0; right: 0;
// //           padding: 32px 16px 16px;
// //           background: linear-gradient(to top, rgba(0,0,0,0.80) 0%, transparent 100%);
// //         }
// //         .featured-card-caption .quote {
// //           font-family: 'Georgia', 'Times New Roman', serif;
// //           font-style: italic;
// //           font-size: 0.80rem;
// //           color: rgba(255, 220, 120, 0.95);
// //           line-height: 1.4;
// //           margin-bottom: 2px;
// //         }
// //         .featured-card-caption .sub {
// //           font-size: 0.68rem;
// //           color: rgba(255, 255, 255, 0.55);
// //           letter-spacing: 0.06em;
// //           text-transform: uppercase;
// //         }
// //         /* Gold shimmer corner accent */
// //         .featured-card::after {
// //           content: '';
// //           position: absolute;
// //           top: 0; left: 0;
// //           width: 60%; height: 40%;
// //           background: linear-gradient(135deg, rgba(255,210,80,0.18) 0%, transparent 60%);
// //           pointer-events: none;
// //           z-index: 1;
// //         }

// //         /* ── Orbit images ── */
// //         .orbit-img {
// //           position: absolute;
// //           border-radius: 14px;
// //           overflow: hidden;
// //           transition: transform 0.5s cubic-bezier(0.22, 1, 0.36, 1),
// //                       box-shadow 0.4s ease;
// //           z-index: 3;
// //           cursor: default;
// //         }
// //         .orbit-img img {
// //           width: 100%;
// //           height: 100%;
// //           object-fit: cover;
// //           display: block;
// //         }
// //         .orbit-img:hover {
// //           transform: scale(1.08) !important;
// //           box-shadow: 0 16px 48px rgba(0,0,0,0.55), 0 0 0 2px rgba(255,200,80,0.45) !important;
// //           z-index: 10;
// //         }
// //         .orbit-img-shine {
// //           position: absolute;
// //           inset: 0;
// //           background: linear-gradient(135deg, rgba(255,255,255,0.10) 0%, transparent 50%);
// //           pointer-events: none;
// //         }

// //         /* ── Float animations — each orbit image has its own rhythm ── */
// //         @keyframes float-a {
// //           0%, 100% { transform: translateY(0px)   rotate(-3deg); }
// //           50%       { transform: translateY(-12px) rotate(-3deg); }
// //         }
// //         @keyframes float-b {
// //           0%, 100% { transform: translateY(0px)  rotate(4deg); }
// //           50%       { transform: translateY(10px) rotate(4deg); }
// //         }
// //         @keyframes float-c {
// //           0%, 100% { transform: translateY(0px)   rotate(-2deg); }
// //           50%       { transform: translateY(-8px)  rotate(-2deg); }
// //         }
// //         @keyframes float-d {
// //           0%, 100% { transform: translateY(0px)  rotate(3deg); }
// //           50%       { transform: translateY(14px) rotate(3deg); }
// //         }

// //         /* Individual orbit sizes + positions + shadows */
// //         .orbit-tl {
// //           width: 118px; height: 148px;
// //           top: 2%;  left: 0%;
// //           box-shadow: 0 12px 36px rgba(0,0,0,0.40), 0 0 0 1.5px rgba(255,200,80,0.18);
// //           animation: float-a 5.2s ease-in-out infinite;
// //         }
// //         .orbit-tr {
// //           width: 100px; height: 130px;
// //           top: 0%;  right: 2%;
// //           box-shadow: 0 10px 30px rgba(0,0,0,0.40), 0 0 0 1.5px rgba(255,200,80,0.14);
// //           animation: float-b 6.0s ease-in-out infinite 0.8s;
// //         }
// //         .orbit-ml {
// //           width: 88px; height: 110px;
// //           top: 42%; left: -4%;
// //           box-shadow: 0  8px 24px rgba(0,0,0,0.38), 0 0 0 1.5px rgba(255,200,80,0.12);
// //           animation: float-c 4.8s ease-in-out infinite 1.4s;
// //         }
// //         .orbit-mr {
// //           width: 96px; height: 120px;
// //           top: 38%; right: -3%;
// //           box-shadow: 0 10px 28px rgba(0,0,0,0.40), 0 0 0 1.5px rgba(255,200,80,0.15);
// //           animation: float-d 5.6s ease-in-out infinite 0.4s;
// //         }
// //         .orbit-bl {
// //           width: 108px; height: 136px;
// //           bottom: 0%; left: 5%;
// //           box-shadow: 0 12px 32px rgba(0,0,0,0.42), 0 0 0 1.5px rgba(255,200,80,0.16);
// //           animation: float-b 5.0s ease-in-out infinite 1.2s;
// //         }
// //         .orbit-br {
// //           width: 94px; height: 118px;
// //           bottom: 2%; right: 4%;
// //           box-shadow: 0  8px 26px rgba(0,0,0,0.36), 0 0 0 1.5px rgba(255,200,80,0.12);
// //           animation: float-a 6.4s ease-in-out infinite 2.0s;
// //         }

// //         /* ── Connecting thread lines (SVG overlay) ── */
// //         .orbit-threads {
// //           position: absolute;
// //           inset: 0;
// //           width: 100%; height: 100%;
// //           pointer-events: none;
// //           z-index: 2;
// //           opacity: 0.30;
// //         }

// //         /* ── Foundation year badge ── */
// //         .hero-year-badge {
// //           position: absolute;
// //           top: 6%;
// //           left: 50%;
// //           transform: translateX(-50%);
// //           z-index: 5;
// //           background: rgba(255, 200, 80, 0.12);
// //           border: 1px solid rgba(255, 200, 80, 0.30);
// //           border-radius: 99px;
// //           padding: 4px 14px;
// //           font-size: 0.68rem;
// //           letter-spacing: 0.12em;
// //           color: rgba(255, 220, 120, 0.80);
// //           text-transform: uppercase;
// //           backdrop-filter: blur(4px);
// //           white-space: nowrap;
// //         }

// //         /* ── Responsive ── */
// //         @media (max-width: 1199px) {
// //           .featured-card       { width: 200px; }
// //           .orbit-tl, .orbit-bl { left:  2%; }
// //           .orbit-tr, .orbit-br { right: 2%; }
// //           .orbit-ml            { left: -2%; }
// //           .orbit-mr            { right:-1%; }
// //         }
// //         @media (max-width: 991px) {
// //           .cf-hero-scene       { min-height: 400px; }
// //           .featured-card       { width: 170px; }
// //           .scene-ring-1        { width: 320px; height: 320px; }
// //           .scene-ring-2        { width: 440px; height: 440px; }
// //           .orbit-tl  { width:88px; height:112px; top:0%;   left:0%;  }
// //           .orbit-tr  { width:76px; height: 96px; top:0%;   right:0%; }
// //           .orbit-ml  { width:68px; height: 86px; top:42%;  left:-2%;}
// //           .orbit-mr  { width:72px; height: 92px; top:40%;  right:-1%;}
// //           .orbit-bl  { width:82px; height:104px; bottom:0%;left:4%;  }
// //           .orbit-br  { width:70px; height: 88px; bottom:1%;right:2%; }
// //         }
// //       `}</style>

// //       <section className="cf-hero">
// //         <div className="container position-relative" style={{ zIndex: 1 }}>
// //           <div className="row align-items-center g-5">

// //             {/* ── Left: Text (unchanged) ── */}
// //             <div className="col-lg-6">
// //               <span className="eyebrow-badge anim-fade anim-delay-1">
// //                 <i className="bi bi-flower1"></i>
// //                 {t('home.heroEyebrow')}
// //               </span>

// //               <h1 className="hero-title mb-2 anim-fade-up anim-delay-2">
// //                 <em>{t('home.heroTitleEm')}</em>
// //               </h1>

// //               <p className="hero-subtitle mb-3 anim-fade-up anim-delay-3">
// //                 {t('home.heroSubtitle')}
// //               </p>

// //               <p className="hero-desc mb-4 anim-fade-up anim-delay-4">
// //                 {t('home.heroDesc')}
// //               </p>

// //               <div className="d-flex flex-wrap gap-3 mb-4 anim-fade-up anim-delay-5">
// //                 <Link to="/who-is-chaitralee" className="btn-brand">
// //                   {t('home.ctaLearnMore')}
// //                   <i className="bi bi-arrow-right"></i>
// //                 </Link>
// //                 <Link to="/you-can" className="btn-brand-outline">
// //                   {t('home.ctaJoin')}
// //                   <i className="bi bi-heart"></i>
// //                 </Link>
// //               </div>

// //               <div className="hero-dates-badge anim-fade anim-delay-6">
// //                 <div className="text-center">
// //                   <div className="hero-date-label">{t('home.heroBorn')}</div>
// //                   <div className="hero-date-desc">{t('home.heroBornLabel')}</div>
// //                 </div>
// //                 <div className="hero-divider-v"></div>
// //                 <div className="text-center">
// //                   <div className="hero-date-label" style={{ color: 'rgba(253,246,236,0.65)' }}>
// //                     {t('home.heroPassed')}
// //                   </div>
// //                   <div className="hero-date-desc">{t('home.heroPassedLabel')}</div>
// //                 </div>
// //               </div>
// //             </div>

// //             {/* ── Right: Orbit scene ── */}
// //             <div className="col-lg-6 anim-fade anim-delay-3">
// //               <div className="cf-hero-scene" ref={sceneRef}>

// //                 {/* Decorative rings */}
// //                 <div className="scene-ring scene-ring-1" />
// //                 <div className="scene-ring scene-ring-2" />

// //                 {/* Subtle year label */}
// //                 <div className="hero-year-badge">Chaitralee Foundation · Pune</div>

// //                 {/* SVG thread lines connecting orbits to center */}
// //                 <svg className="orbit-threads" viewBox="0 0 520 520" preserveAspectRatio="xMidYMid meet">
// //                   <line x1="260" y1="260" x2="90"  y2="80"  stroke="rgba(255,200,80,1)" strokeWidth="0.8" strokeDasharray="4 6"/>
// //                   <line x1="260" y1="260" x2="430" y2="60"  stroke="rgba(255,200,80,1)" strokeWidth="0.8" strokeDasharray="4 6"/>
// //                   <line x1="260" y1="260" x2="56"  y2="250" stroke="rgba(255,200,80,1)" strokeWidth="0.8" strokeDasharray="4 6"/>
// //                   <line x1="260" y1="260" x2="464" y2="240" stroke="rgba(255,200,80,1)" strokeWidth="0.8" strokeDasharray="4 6"/>
// //                   <line x1="260" y1="260" x2="100" y2="440" stroke="rgba(255,200,80,1)" strokeWidth="0.8" strokeDasharray="4 6"/>
// //                   <line x1="260" y1="260" x2="420" y2="450" stroke="rgba(255,200,80,1)" strokeWidth="0.8" strokeDasharray="4 6"/>
// //                 </svg>

// //                 {/* Orbit images — top-left */}
// //                 <OrbitImage src={img1} className="orbit-tl" data-depth="1.2" />

// //                 {/* Orbit images — top-right */}
// //                 <OrbitImage src={img2} className="orbit-tr" data-depth="0.8" />

// //                 {/* Orbit images — mid-left */}
// //                 <OrbitImage src={img2} className="orbit-ml" data-depth="1.5" />

// //                 {/* Orbit images — mid-right */}
// //                 <OrbitImage src={img1} className="orbit-mr" data-depth="1.0" />

// //                 {/* Orbit images — bottom-left */}
// //                 <OrbitImage src={img1} className="orbit-bl" data-depth="0.9" />

// //                 {/* Orbit images — bottom-right */}
// //                 <OrbitImage src={img2} className="orbit-br" data-depth="1.3" />

// //                 {/* Featured center card */}
// //                 <div className="featured-card" data-depth="0.3">
// //                   <img src={featured} alt="Chaitralee Foundation" />
// //                   <div className="featured-card-caption">
// //                     <div className="quote">"Rose Colour Glasses"</div>
// //                     <div className="sub">Her philosophy. Her legacy.</div>
// //                   </div>
// //                 </div>

// //               </div>
// //             </div>

// //           </div>
// //         </div>
// //       </section>
// //     </>
// //   );
// // };

// // export default HomeBanner;

// import React, { useEffect, useRef } from 'react';
// import { Link } from 'react-router-dom';
// import { useLanguage } from '../../context/LanguageContext';

// // ─── Floating orbit image ────────────────────────────────────────────────────
// const OrbitImage = ({ src, style, className = '' }) => (
//   <div className={`orbit-img ${className}`} style={style}>
//     <img src={src} alt="" loading="lazy" />
//     <div className="orbit-img-shine" />
//   </div>
// );

// // ─── Main Component ──────────────────────────────────────────────────────────
// const HomeBanner = () => {
//   const { t } = useLanguage();
//   const sceneRef = useRef(null);

//   // Subtle parallax on mouse move
//   useEffect(() => {
//     const scene = sceneRef.current;
//     if (!scene) return;

//     const onMove = (e) => {
//       const rect = scene.getBoundingClientRect();
//       const cx = rect.left + rect.width / 2;
//       const cy = rect.top + rect.height / 2;
//       const dx = (e.clientX - cx) / rect.width;   // -0.5 … 0.5
//       const dy = (e.clientY - cy) / rect.height;

//       scene.querySelectorAll('[data-depth]').forEach(el => {
//         const d = parseFloat(el.dataset.depth);
//         el.style.transform = `translate(${dx * d * 22}px, ${dy * d * 18}px)`;
//       });
//     };

//     window.addEventListener('mousemove', onMove);
//     return () => window.removeEventListener('mousemove', onMove);
//   }, []);

//   // ── Image paths — swap freely ────────────────────────────────────────────
//   const featured = '/assets/images/417.jpg.jpeg';
//   const img1 = '/assets/images/265.jpg.jpeg';
//   const img2 = '/assets/images/370.jpg.jpeg';
//   const img3 = '/assets/images/788.jpg.jpeg';
//   const img4 = '/assets/images/524.jpg.jpeg';
//   const img5 = '/assets/images/549.jpg.jpeg';
//   const img6 = '/assets/images/700.jpg.jpeg';
//   // ────────────────────────────────────────────────────────────────────────

//   return (
//     <>
//       <style>{`
//         /* ═══════════════════════════════════════════════════════
//            HERO SCENE
//         ═══════════════════════════════════════════════════════ */
//         .cf-hero-scene {
//           position: relative;
//           width: 100%;
//           min-height: 580px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//         }

//         /* ── Decorative rings ── */
//         .scene-ring {
//           position: absolute;
//           border-radius: 50%;
//           border: 1px solid rgba(255, 200, 100, 0.12);
//           pointer-events: none;
//         }
//         .scene-ring-1 {
//           width: 420px; height: 420px;
//           top: 50%; left: 50%;
//           transform: translate(-50%, -50%);
//           animation: ring-pulse 6s ease-in-out infinite;
//         }
//         .scene-ring-2 {
//           width: 560px; height: 560px;
//           top: 50%; left: 50%;
//           transform: translate(-50%, -50%);
//           border-color: rgba(255, 200, 100, 0.07);
//           animation: ring-pulse 6s ease-in-out infinite 1.5s;
//         }
//         @keyframes ring-pulse {
//           0%, 100% { opacity: 0.6; }
//           50%       { opacity: 1;   }
//         }

//         /* ── Featured (center) image ── */
//         .featured-card {
//           position: relative;
//           z-index: 4;
//           width: 240px;
//           flex-shrink: 0;
//           border-radius: 22px;
//           overflow: hidden;
//           box-shadow:
//             0 0 0 2px rgba(255, 200, 80, 0.30),
//             0 24px 64px rgba(0, 0, 0, 0.55),
//             0  8px 20px rgba(0, 0, 0, 0.35);
//           width: 300px;
//           transition: transform 0.6s cubic-bezier(0.22, 1, 0.36, 1);
//         }
//         .featured-card:hover {
//           transform: scale(1.03) translateY(-4px);
//         }
//         .featured-card img {
//           width: 100%;
//           aspect-ratio: 3 / 4;
//           object-fit: cover;
//           display: block;
//         }
//         .featured-card-caption {
//           position: absolute;
//           bottom: 0; left: 0; right: 0;
//           padding: 32px 16px 16px;
//           background: linear-gradient(to top, rgba(0,0,0,0.80) 0%, transparent 100%);
//         }
//         .featured-card-caption .quote {
//           font-family: 'Georgia', 'Times New Roman', serif;
//           font-style: italic;
//           font-size: 0.80rem;
//           color: rgba(255, 220, 120, 0.95);
//           line-height: 1.4;
//           margin-bottom: 2px;
//         }
//         .featured-card-caption .sub {
//           font-size: 0.68rem;
//           color: rgba(255, 255, 255, 0.55);
//           letter-spacing: 0.06em;
//           text-transform: uppercase;
//         }
//         /* Gold shimmer corner accent */
//         .featured-card::after {
//           content: '';
//           position: absolute;
//           top: 0; left: 0;
//           width: 60%; height: 40%;
//           background: linear-gradient(135deg, rgba(255,210,80,0.18) 0%, transparent 60%);
//           pointer-events: none;
//           z-index: 1;
//         }

//         /* ── Orbit images ── */
//         .orbit-img {
//           position: absolute;
//           border-radius: 14px;
//           overflow: hidden;
//           transition: transform 0.5s cubic-bezier(0.22, 1, 0.36, 1),
//                       box-shadow 0.4s ease;
//           z-index: 3;
//           cursor: default;
//         }
//         .orbit-img img {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//           display: block;
//         }
//         .orbit-img:hover {
//           transform: scale(1.08) !important;
//           box-shadow: 0 16px 48px rgba(0,0,0,0.55), 0 0 0 2px rgba(255,200,80,0.45) !important;
//           z-index: 10;
//         }
//         .orbit-img-shine {
//           position: absolute;
//           inset: 0;
//           background: linear-gradient(135deg, rgba(255,255,255,0.10) 0%, transparent 50%);
//           pointer-events: none;
//         }

//         /* ── Float animations — each orbit image has its own rhythm ── */
//         @keyframes float-a {
//           0%, 100% { transform: translateY(0px)   rotate(-3deg); }
//           50%       { transform: translateY(-12px) rotate(-3deg); }
//         }
//         @keyframes float-b {
//           0%, 100% { transform: translateY(0px)  rotate(4deg); }
//           50%       { transform: translateY(10px) rotate(4deg); }
//         }
//         @keyframes float-c {
//           0%, 100% { transform: translateY(0px)   rotate(-2deg); }
//           50%       { transform: translateY(-8px)  rotate(-2deg); }
//         }
//         @keyframes float-d {
//           0%, 100% { transform: translateY(0px)  rotate(3deg); }
//           50%       { transform: translateY(14px) rotate(3deg); }
//         }

//         /* Individual orbit sizes + positions + shadows */
//         .orbit-tl {
//           width: 118px; height: 148px;
//           top: 2%;  left: 0%;
//           box-shadow: 0 12px 36px rgba(0,0,0,0.40), 0 0 0 1.5px rgba(255,200,80,0.18);
//           animation: float-a 5.2s ease-in-out infinite;
//         }
//         .orbit-tr {
//           width: 100px; height: 130px;
//           top: 0%;  right: 2%;
//           box-shadow: 0 10px 30px rgba(0,0,0,0.40), 0 0 0 1.5px rgba(255,200,80,0.14);
//           animation: float-b 6.0s ease-in-out infinite 0.8s;
//         }
//         .orbit-ml {
//           width: 88px; height: 110px;
//           top: 42%; left: -4%;
//           box-shadow: 0  8px 24px rgba(0,0,0,0.38), 0 0 0 1.5px rgba(255,200,80,0.12);
//           animation: float-c 4.8s ease-in-out infinite 1.4s;
//         }
//         .orbit-mr {
//           width: 96px; height: 120px;
//           top: 38%; right: -3%;
//           box-shadow: 0 10px 28px rgba(0,0,0,0.40), 0 0 0 1.5px rgba(255,200,80,0.15);
//           animation: float-d 5.6s ease-in-out infinite 0.4s;
//         }
//         .orbit-bl {
//           width: 108px; height: 136px;
//           bottom: 0%; left: 5%;
//           box-shadow: 0 12px 32px rgba(0,0,0,0.42), 0 0 0 1.5px rgba(255,200,80,0.16);
//           animation: float-b 5.0s ease-in-out infinite 1.2s;
//         }
//         .orbit-br {
//           width: 94px; height: 118px;
//           bottom: 2%; right: 4%;
//           box-shadow: 0  8px 26px rgba(0,0,0,0.36), 0 0 0 1.5px rgba(255,200,80,0.12);
//           animation: float-a 6.4s ease-in-out infinite 2.0s;
//         }

//         /* ── Connecting thread lines (SVG overlay) ── */
//         .orbit-threads {
//           position: absolute;
//           inset: 0;
//           width: 100%; height: 100%;
//           pointer-events: none;
//           z-index: 2;
//           opacity: 0.30;
//         }

//         /* ── Foundation year badge ── */
//         .hero-year-badge {
//           position: absolute;
//           top: 6%;
//           left: 50%;
//           transform: translateX(-50%);
//           z-index: 5;
//           background: rgba(255, 200, 80, 0.12);
//           border: 1px solid rgba(255, 200, 80, 0.30);
//           border-radius: 99px;
//           padding: 4px 14px;
//           font-size: 0.68rem;
//           letter-spacing: 0.12em;
//           color: rgba(255, 220, 120, 0.80);
//           text-transform: uppercase;
//           backdrop-filter: blur(4px);
//           white-space: nowrap;
//         }

//         /* ── Responsive ── */
//         @media (max-width: 1199px) {
//           .featured-card       { width: 260px; }
//           .orbit-tl, .orbit-bl { left:  2%; }
//           .orbit-tr, .orbit-br { right: 2%; }
//           .orbit-ml            { left: -2%; }
//           .orbit-mr            { right:-1%; }
//         }
//         @media (max-width: 991px) {
//           .cf-hero-scene       { min-height: 400px; }
//           .featured-card       { width: 210px; }
//           .scene-ring-1        { width: 320px; height: 320px; }
//           .scene-ring-2        { width: 440px; height: 440px; }
//           .orbit-tl  { width:88px; height:112px; top:0%;   left:0%;  }
//           .orbit-tr  { width:76px; height: 96px; top:0%;   right:0%; }
//           .orbit-ml  { width:68px; height: 86px; top:42%;  left:-2%;}
//           .orbit-mr  { width:72px; height: 92px; top:40%;  right:-1%;}
//           .orbit-bl  { width:82px; height:104px; bottom:0%;left:4%;  }
//           .orbit-br  { width:70px; height: 88px; bottom:1%;right:2%; }
//         }
//       `}</style>

//       <section className="cf-hero">
//         <div className="container position-relative" style={{ zIndex: 1 }}>
//           <div className="row align-items-center g-5">

//             {/* ── Left: Text (unchanged) ── */}
//             <div className="col-lg-6">
//               <span className="eyebrow-badge anim-fade anim-delay-1">
//                 <i className="bi bi-flower1"></i>
//                 {t('home.heroEyebrow')}
//               </span>

//               <h1 className="hero-title mb-2 anim-fade-up anim-delay-2">
//                 <em>{t('home.heroTitleEm')}</em>
//               </h1>

//               <p className="hero-subtitle mb-3 anim-fade-up anim-delay-3">
//                 {t('home.heroSubtitle')}
//               </p>

//               <p className="anim-fade-up anim-delay-3" style={{ fontSize: '0.78rem', letterSpacing: '0.06em', color: 'rgba(255,255,255,0.55)', marginBottom: '0.75rem', marginTop: '-0.5rem' }}>
//                 Reg No : E-0013988
//               </p>

//               <p className="hero-desc mb-4 anim-fade-up anim-delay-4">
//                 {t('home.heroDesc')}
//               </p>

//               <div className="d-flex flex-wrap gap-3 mb-4 anim-fade-up anim-delay-5">
//                 <Link to="/who-is-chaitralee" className="btn-brand">
//                   {t('home.ctaLearnMore')}
//                   <i className="bi bi-arrow-right"></i>
//                 </Link>
//                 <Link to="/you-can" className="btn-brand-outline">
//                   {t('home.ctaJoin')}
//                   <i className="bi bi-heart"></i>
//                 </Link>
//               </div>

//               <div className="hero-dates-badge anim-fade anim-delay-6">
//                 <div className="text-center">
//                   <div className="hero-date-label">{t('home.heroBorn')}</div>
//                   <div className="hero-date-desc">{t('home.heroBornLabel')}</div>
//                 </div>
//                 <div className="hero-divider-v"></div>
//                 <div className="text-center">
//                   <div className="hero-date-label" style={{ color: 'rgba(253,246,236,0.65)' }}>
//                     {t('home.heroPassed')}
//                   </div>
//                   <div className="hero-date-desc">{t('home.heroPassedLabel')}</div>
//                 </div>
//               </div>
//             </div>

//             {/* ── Right: Orbit scene ── */}
//             <div className="col-lg-6 anim-fade anim-delay-3">
//               <div className="cf-hero-scene" ref={sceneRef}>

//                 {/* Decorative rings */}
//                 <div className="scene-ring scene-ring-1" />
//                 <div className="scene-ring scene-ring-2" />

//                 {/* Subtle year label */}
//                 <div className="hero-year-badge">Chaitralee Foundation · Pune</div>

//                 {/* SVG thread lines connecting orbits to center */}
//                 <svg className="orbit-threads" viewBox="0 0 520 520" preserveAspectRatio="xMidYMid meet">
//                   <line x1="260" y1="260" x2="90" y2="80" stroke="rgba(255,200,80,1)" strokeWidth="0.8" strokeDasharray="4 6" />
//                   <line x1="260" y1="260" x2="430" y2="60" stroke="rgba(255,200,80,1)" strokeWidth="0.8" strokeDasharray="4 6" />
//                   <line x1="260" y1="260" x2="56" y2="250" stroke="rgba(255,200,80,1)" strokeWidth="0.8" strokeDasharray="4 6" />
//                   <line x1="260" y1="260" x2="464" y2="240" stroke="rgba(255,200,80,1)" strokeWidth="0.8" strokeDasharray="4 6" />
//                   <line x1="260" y1="260" x2="100" y2="440" stroke="rgba(255,200,80,1)" strokeWidth="0.8" strokeDasharray="4 6" />
//                   <line x1="260" y1="260" x2="420" y2="450" stroke="rgba(255,200,80,1)" strokeWidth="0.8" strokeDasharray="4 6" />
//                 </svg>

//                 {/* Orbit images — top-left */}
//                 <OrbitImage src={img1} className="orbit-tl" data-depth="1.2" />

//                 {/* Orbit images — top-right */}
//                 <OrbitImage src={img2} className="orbit-tr" data-depth="0.8" />

//                 {/* Orbit images — mid-left */}
//                 <OrbitImage src={img3} className="orbit-ml" data-depth="1.5" />

//                 {/* Orbit images — mid-right */}
//                 <OrbitImage src={img4} className="orbit-mr" data-depth="1.0" />

//                 {/* Orbit images — bottom-left */}
//                 <OrbitImage src={img5} className="orbit-bl" data-depth="0.9" />

//                 {/* Orbit images — bottom-right */}
//                 <OrbitImage src={img6} className="orbit-br" data-depth="1.3" />

//                 {/* Featured center card */}
//                 <div className="featured-card" data-depth="0.3">
//                   <img src={featured} alt="Chaitralee Foundation" />
//                   {/* <div className="featured-card-caption">
//                     <div className="quote">"Rose Colour Glasses"</div>
//                     <div className="sub">Her philosophy. Her legacy.</div>
//                   </div> */}
//                 </div>

//               </div>
//             </div>

//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default HomeBanner;




// import React, { useEffect, useRef } from 'react';
// import { Link } from 'react-router-dom';
// import { useLanguage } from '../../context/LanguageContext';

// const HomeBanner = () => {
//   const { t } = useLanguage();
//   const bgRef = useRef(null);

//   // Subtle parallax on mouse move
//   useEffect(() => {
//     const onMove = (e) => {
//       if (!bgRef.current) return;
//       const dx = (e.clientX / window.innerWidth - 0.5) * 14;
//       const dy = (e.clientY / window.innerHeight - 0.5) * 8;
//       bgRef.current.style.transform = `scale(1.05) translate(${dx * 0.35}px, ${dy * 0.35}px)`;
//     };
//     window.addEventListener('mousemove', onMove);
//     return () => window.removeEventListener('mousemove', onMove);
//   }, []);

//   return (
//     <>
//       <style>{`
//         /* ═══════════════════════════════════════════
//            CINEMATIC HERO  –  single image, text right
//         ═══════════════════════════════════════════ */

//         .cin-hero {
//           position: relative;
//           width: 100%;
//           min-height: 100vh;
//           overflow: hidden;
//           display: flex;
//           align-items: center;
//         }

//         /* Full-bleed background photo */
//         .cin-bg {
//           position: absolute;
//           inset: 0;
//           width: 100%;
//           height: 100%;
//         object-fit: contain;
// object-position: 25% center;
// transform: scale(1.0);
// background-color: #1a0008;
//           transition: transform 0.12s linear;
//           z-index: 0;
//           filter: brightness(0.78);
//         }

//         /* Left → transparent, right → deep maroon  */
//         .cin-gradient {
//           position: absolute;
//           inset: 0;
//           background: linear-gradient(
//             100deg,
//             transparent        0%,
//             transparent       30%,
//             rgba(65, 8, 28, 0.55)  46%,
//             rgba(50, 4, 20, 0.85)  60%,
//             rgba(35, 2, 14, 0.97)  100%
//           );
//           z-index: 1;
//         }

//         /* Bottom vignette */
//         .cin-vignette {
//           position: absolute;
//           bottom: 0; left: 0; right: 0;
//           height: 180px;
//           background: linear-gradient(to top, rgba(25,2,12,0.65) 0%, transparent 100%);
//           z-index: 1;
//           pointer-events: none;
//         }

//         /* Content sits over everything */
//         .cin-body {
//           position: relative;
//           z-index: 2;
//           width: 100%;
//           padding: 130px 0 90px;
//         }

//         /* Text column — pushed to the right */
//         .cin-text {
//           margin-left: auto;
//           max-width: 540px;
//           padding-right: 1.5rem;
//         }

//         /* Eyebrow */
//         .cin-eyebrow {
//           display: inline-flex;
//           align-items: center;
//           gap: 7px;
//           background: rgba(255, 200, 80, 0.10);
//           border: 1px solid rgba(255, 200, 80, 0.26);
//           border-radius: 99px;
//           padding: 5px 15px;
//           font-size: 0.70rem;
//           letter-spacing: 0.12em;
//           color: rgba(255, 220, 130, 0.88);
//           text-transform: uppercase;
//           margin-bottom: 1.1rem;
//         }

//         /* Title */
//         .cin-title {
//           font-size: clamp(2.6rem, 5.5vw, 4.6rem);
//           font-weight: 800;
//           line-height: 1.08;
//           color: #f5d9a0;
//           font-family: 'Tiro Devanagari Marathi', 'Hind', serif;
//           margin-bottom: 0.55rem;
//         }

//         /* Subtitle */
//         .cin-sub {
//           font-size: 1.10rem;
//           font-style: italic;
//           color: rgba(255, 228, 185, 0.80);
//           font-family: 'Tiro Devanagari Marathi', 'Hind', serif;
//           margin-bottom: 0.35rem;
//         }

//         /* Reg number */
//         .cin-reg {
//           font-size: 0.70rem;
//           letter-spacing: 0.09em;
//           color: rgba(255, 255, 255, 0.40);
//           margin-bottom: 0.90rem;
//         }

//         /* Description */
//         .cin-desc {
//           font-size: 0.88rem;
//           color: rgba(255, 255, 255, 0.62);
//           line-height: 1.75;
//           max-width: 400px;
//           margin-bottom: 1.8rem;
//         }

//         /* CTA row */
//         .cin-cta {
//           display: flex;
//           flex-wrap: wrap;
//           gap: 12px;
//           margin-bottom: 2rem;
//         }

//         /* Dates badge */
//         .cin-dates {
//           display: inline-flex;
//           align-items: center;
//           gap: 18px;
//           background: rgba(255, 255, 255, 0.06);
//           border: 1px solid rgba(255, 255, 255, 0.11);
//           border-radius: 14px;
//           padding: 10px 22px;
//           backdrop-filter: blur(8px);
//         }
//         .cin-date-val {
//           font-size: 0.98rem;
//           font-weight: 700;
//           color: #f5d9a0;
//           font-family: 'Tiro Devanagari Marathi', 'Hind', serif;
//         }
//         .cin-date-lbl {
//           font-size: 0.66rem;
//           color: rgba(255, 255, 255, 0.44);
//           letter-spacing: 0.05em;
//         }
//         .cin-date-sep {
//           width: 1px;
//           height: 38px;
//           background: rgba(255, 255, 255, 0.16);
//           flex-shrink: 0;
//         }

//         /* Scroll hint */
//         .cin-scroll {
//           position: absolute;
//           bottom: 26px;
//           left: 50%;
//           transform: translateX(-50%);
//           z-index: 3;
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           gap: 5px;
//           opacity: 0.32;
//           pointer-events: none;
//           animation: sbob 2.2s ease-in-out infinite;
//         }
//         @keyframes sbob {
//           0%,100%{ transform: translateX(-50%) translateY(0);   }
//           50%    { transform: translateX(-50%) translateY(7px);  }
//         }
//         .cin-scroll span {
//           font-size: 0.58rem;
//           letter-spacing: 0.14em;
//           text-transform: uppercase;
//           color: #fff;
//         }
//         .cin-scroll i { font-size: 1rem; color: #fff; }

//         /* ── Responsive ── */
//         @media (max-width: 991px) {
//           .cin-gradient {
//             background: linear-gradient(
//               175deg,
//               transparent         0%,
//               rgba(50,4,20,0.55)  38%,
//               rgba(35,2,14,0.92)  65%,
//               rgba(25,2,10,1)    100%
//             );
//           }
//           .cin-text {
//             margin-left: 0;
//             max-width: 100%;
//             padding: 0 1rem;
//           }
//           .cin-body { padding: 90px 0 60px; }
//         }
//         @media (max-width: 575px) {
//           .cin-hero  { min-height: 100svh; }
//           .cin-title { font-size: clamp(2rem, 9vw, 3rem); }
//         }
//       `}</style>

//       <section className="cin-hero">

//         {/* Full-bleed photo */}
//         <img
//           ref={bgRef}
//           className="cin-bg"
//           src="/assets/images/540.jpg.jpeg"
//           alt="Chaitralee Foundation"
//         />

//         {/* Gradient fade */}
//         <div className="cin-gradient" />
//         <div className="cin-vignette" />

//         {/* Text content */}
//         <div className="cin-body">
//           <div className="container">
//             <div className="cin-text">

//               <div className="cin-eyebrow">
//                 <i className="bi bi-flower1"></i>
//                 {t('home.heroEyebrow')}
//               </div>

//               <h1 className="cin-title">
//                 <em>{t('home.heroTitleEm')}</em>
//               </h1>

//               <p className="cin-sub">{t('home.heroSubtitle')}</p>

//               <p className="cin-reg">Reg No : E-0013988</p>

//               <p className="cin-desc">{t('home.heroDesc')}</p>

//               <div className="cin-cta">
//                 <Link to="/who-is-chaitralee" className="btn-brand">
//                   {t('home.ctaLearnMore')}
//                   <i className="bi bi-arrow-right"></i>
//                 </Link>
//                 <Link to="/you-can" className="btn-brand-outline">
//                   {t('home.ctaJoin')}
//                   <i className="bi bi-heart"></i>
//                 </Link>
//               </div>

//               <div className="cin-dates">
//                 <div className="text-center">
//                   <div className="cin-date-val">{t('home.heroBorn')}</div>
//                   <div className="cin-date-lbl">{t('home.heroBornLabel')}</div>
//                 </div>
//                 <div className="cin-date-sep" />
//                 <div className="text-center">
//                   <div className="cin-date-val" style={{ color: 'rgba(253,246,236,0.52)' }}>
//                     {t('home.heroPassed')}
//                   </div>
//                   <div className="cin-date-lbl">{t('home.heroPassedLabel')}</div>
//                 </div>
//               </div>

//             </div>
//           </div>
//         </div>

//         {/* Scroll hint */}
//         <div className="cin-scroll">
//           <span>Scroll</span>
//           <i className="bi bi-chevron-down"></i>
//         </div>

//       </section>
//     </>
//   );
// };

// export default HomeBanner;

import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

const HomeBanner = () => {
  const { t } = useLanguage();
  const bgRef = useRef(null);

  useEffect(() => {
    const onMove = (e) => {
      if (!bgRef.current) return;
      const dx = (e.clientX / window.innerWidth - 0.5) * 14;
      const dy = (e.clientY / window.innerHeight - 0.5) * 8;
      bgRef.current.style.transform = `scale(1.05) translate(${dx * 0.35}px, ${dy * 0.35}px)`;
    };
    window.addEventListener('mousemove', onMove);
    return () => window.removeEventListener('mousemove', onMove);
  }, []);

  return (
    <>
      <style>{`
        .cin-hero {
          position: relative;
          width: 100%;
          min-height: 100vh;
          overflow: hidden;
          display: flex;
          align-items: center;
          background-color: #5a0a2a;
        }

        /* ✅ Photo pinned to the LEFT half */
        .cin-bg {
          position: absolute;
          left: 0;
          top: 0;
          width: 58%;
          height: 100%;
          object-fit: cover;
          object-position: center top;
          transition: transform 0.12s linear;
          z-index: 0;
          filter: brightness(0.85);
        }

        /* ✅ Gradient: transparent on left (photo shows) → solid pink on right (text bg) */
        .cin-gradient {
          position: absolute;
          inset: 0;
          background: linear-gradient(
            90deg,
            transparent               18%,
            rgba(90, 10, 42, 0.15)    32%,
            rgba(90, 10, 42, 0.60)    46%,
            rgba(90, 10, 42, 0.92)    58%,
            #5a0a2a                   70%,
            #5a0a2a                  100%
          );
          z-index: 1;
        }

        /* Bottom vignette */
        .cin-vignette {
          position: absolute;
          bottom: 0; left: 0; right: 0;
          height: 180px;
          background: linear-gradient(to top, rgba(60, 5, 28, 0.55) 0%, transparent 100%);
          z-index: 1;
          pointer-events: none;
        }

        .cin-body {
          position: relative;
          z-index: 2;
          width: 100%;
          padding: 130px 0 90px;
        }

        /* ✅ Text column — RIGHT side */
        .cin-text {
          margin-left: auto;
          margin-right: 0;
          max-width: 520px;
          padding-right: 1.5rem;
        }

        .cin-eyebrow {
          display: inline-flex;
          align-items: center;
          gap: 7px;
          background: rgba(255, 200, 80, 0.12);
          border: 1px solid rgba(255, 200, 80, 0.30);
          border-radius: 99px;
          padding: 5px 15px;
          font-size: 0.70rem;
          letter-spacing: 0.12em;
          color: rgba(255, 220, 130, 0.90);
          text-transform: uppercase;
          margin-bottom: 1.1rem;
        }

        .cin-title {
          font-size: clamp(2.6rem, 5.5vw, 4.6rem);
          font-weight: 800;
          line-height: 1.08;
          color: #f5d9a0;
          font-family: 'Tiro Devanagari Marathi', 'Hind', serif;
          margin-bottom: 0.55rem;
        }

        .cin-sub {
          font-size: 1.10rem;
          font-style: italic;
          color: rgba(255, 228, 185, 0.82);
          font-family: 'Tiro Devanagari Marathi', 'Hind', serif;
          margin-bottom: 0.35rem;
        }

        .cin-reg {
          font-size: 0.70rem;
          letter-spacing: 0.09em;
          color: rgba(255, 255, 255, 0.45);
          margin-bottom: 0.90rem;
        }

      .cin-desc {
    font-size: clamp(1rem, 2vw, 1.25rem);
    color: rgba(255, 255, 255, 0.68);
    line-height: 1.75;
    max-width: 400px;
    margin-bottom: 1.8rem;
}

        .cin-cta {
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          margin-bottom: 2rem;
        }

        .cin-dates {
          display: inline-flex;
          align-items: center;
          gap: 18px;
          background: rgba(255, 255, 255, 0.07);
          border: 1px solid rgba(255, 255, 255, 0.14);
          border-radius: 14px;
          padding: 10px 22px;
          backdrop-filter: blur(8px);
        }
        .cin-date-val {
          font-size: 0.98rem;
          font-weight: 700;
          color: #f5d9a0;
          font-family: 'Tiro Devanagari Marathi', 'Hind', serif;
        }
        .cin-date-lbl {
          font-size: 0.66rem;
          color: rgba(255, 255, 255, 0.46);
          letter-spacing: 0.05em;
        }
        .cin-date-sep {
          width: 1px;
          height: 38px;
          background: rgba(255, 255, 255, 0.18);
          flex-shrink: 0;
        }

        .cin-scroll {
          position: absolute;
          bottom: 26px;
          left: 50%;
          transform: translateX(-50%);
          z-index: 3;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 5px;
          opacity: 0.35;
          pointer-events: none;
          animation: sbob 2.2s ease-in-out infinite;
        }
        @keyframes sbob {
          0%,100%{ transform: translateX(-50%) translateY(0);  }
          50%    { transform: translateX(-50%) translateY(7px); }
        }
        .cin-scroll span { font-size: 0.58rem; letter-spacing: 0.14em; text-transform: uppercase; color: #fff; }
        .cin-scroll i    { font-size: 1rem; color: #fff; }

        /* ── Responsive ── */
        @media (max-width: 991px) {
          .cin-bg {
            width: 100%;
            left: 0;
            opacity: 0.30;
          }
          .cin-gradient {
            background: linear-gradient(
              180deg,
              rgba(90,10,42,0.60)  0%,
              rgba(90,10,42,0.88) 50%,
              #5a0a2a             100%
            );
          }
          .cin-text {
            margin-left: 0;
            max-width: 100%;
            padding: 0 1rem;
          }
          .cin-body { padding: 90px 0 60px; }
        }
        @media (max-width: 575px) {
          .cin-hero  { min-height: 100svh; }
          .cin-title { font-size: clamp(2rem, 9vw, 3rem); }
        }
      `}</style>

      <section className="cin-hero">

        {/* Photo — LEFT side */}
        <img
          ref={bgRef}
          className="cin-bg"
          src="/assets/images/540.jpg.jpeg"
          alt="Chaitralee Foundation"
        />

        <div className="cin-gradient" />
        <div className="cin-vignette" />

        {/* Text content — RIGHT */}
        <div className="cin-body">
          <div className="container">
            <div className="cin-text">

              <div className="cin-eyebrow">
                <i className="bi bi-flower1"></i>
                {t('home.heroEyebrow')}
              </div>

              <h1 className="cin-title">
                <em>{t('home.heroTitleEm')}</em>
              </h1>

              {/* <p className="cin-sub">{t('home.heroSubtitle')}</p> */}

              <p className="cin-desc">{t('home.heroDesc')}</p>
              <p className="cin-reg">Reg No : E-0013988</p>

              <div className="cin-cta">
                <Link to="/who-is-chaitralee" className="btn-brand">
                  {t('home.ctaLearnMore')}
                  <i className="bi bi-arrow-right"></i>
                </Link>
                <Link to="/you-can" className="btn-brand-outline">
                  {t('home.ctaJoin')}
                  <i className="bi bi-heart"></i>
                </Link>
              </div>

              <div className="cin-dates">
                <div className="text-center">
                  <div className="cin-date-val">{t('home.heroBorn')}</div>
                  <div className="cin-date-lbl">{t('home.heroBornLabel')}</div>
                </div>
                <div className="cin-date-sep" />
                <div className="text-center">
                  <div className="cin-date-val" style={{ color: 'rgba(253,246,236,0.55)' }}>
                    {t('home.heroPassed')}
                  </div>
                  <div className="cin-date-lbl">{t('home.heroPassedLabel')}</div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div className="cin-scroll">
          <span>Scroll</span>
          <i className="bi bi-chevron-down"></i>
        </div>

      </section>
    </>
  );
};

export default HomeBanner;